import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Transaction, TransactionAmountCurrency } from '../interfaces';
import { CreditDebitIndicator, CategoryName } from '../enums';
import { UtilsService } from 'account-selector-widget-extended';
import { PRODUCT_KIND } from 'account-details-widget-extended';

@Component({
  selector: 'bn-transaction-list-item',
  templateUrl: 'bn-transaction-list-item.component.html',
})
export class BnTransactionListItemComponent implements OnChanges {
  @Input() categoryIcon: string | undefined;
  @Input() transaction!: Transaction;
  @Input() showBalanceData = true;
  @Input() accountType?: string;
  @Output() selectItem = new EventEmitter<Transaction>();
  validationClassName?: string;

  constructor(private utils: UtilsService) {}

  ngOnChanges(): void {
    this.validationClassName = this.getTransactionAmountClassValidation(this.transaction);
  }

  /**
   * transaction element class validation
   * @param transaction
   */
  getTransactionAmountClassValidation(transaction: Transaction): string {
    let greenIndicator: string | null = CreditDebitIndicator.CRDT;
    let elementClass = '';
    if (!transaction?.transactionAmountCurrency?.amount) {
      elementClass += 'transaction-balance-amount--empty_value ';
    }

    switch (this.accountType) {
      case PRODUCT_KIND.KIND4:
        greenIndicator = null;
        break;
    }

    if (transaction?.creditDebitIndicator === greenIndicator) {
      elementClass += 'transaction-balance-amount--green';
    }

    return elementClass;
  }

  /**
   * Returns debit/credit transaction amount
   * @param transactionAmountCurrency
   * @param creditDebitIndicator
   */
  getTransactionAmount(
    transactionAmountCurrency: TransactionAmountCurrency,
    creditDebitIndicator: CreditDebitIndicator,
    transactionType?: string,
  ): string {
    const amount = this.utils.formatNumberCurrency(transactionAmountCurrency?.amount);
    const transactionAmount = `${transactionAmountCurrency.currencyCode}${amount}`;
    let debitIndicator = '-';
    let creditIndicator = '+';

    switch (transactionType) {
      case PRODUCT_KIND.KIND4:
        creditIndicator = '-';
        debitIndicator = '';
        break;
    }

    switch (creditDebitIndicator) {
      case CreditDebitIndicator.DBIT:
        return `${debitIndicator}${transactionAmount}`;
      case CreditDebitIndicator.CRDT:
        return `${creditIndicator}${transactionAmount}`;
      default:
        return '__ __';
    }
  }

  /**
   * Returns balance data
   * @param currency
   * @param balanceAfterTransaction
   */
  getBalanceData(currency: string, balanceAfterTransaction: number | string): string {
    return currency && balanceAfterTransaction
      ? `${currency}${this.utils.formatNumberCurrency(balanceAfterTransaction)}`
      : '__ __';
  }

  /**
   * Balance validation
   * @param balanceAfterTransaction
   */
  balanceValidation(balanceAfterTransaction: number | string) {
    return balanceAfterTransaction && balanceAfterTransaction !== '-1';
  }

  getCategoryName(value: any) {
    const index = Object.keys(CategoryName).indexOf(value);
    const values = Object.values(CategoryName);
    return values[index] || 'Otros';
  }
}
